/**
 * @description validTypes is to be of patter type/extension -> like image/png, following the Blob.type format
 */
export function isFileTypeValid(
  file: File,
  validTypes: string[],
  isGenericType?: boolean
): boolean {
  return validTypes.includes(
    isGenericType ? file.type.split('/')[0] : file.type
  )
}

export const isFileValidImage = (file: File) =>
  isFileTypeValid(file, ['image'], true)

export const isFileValidPdf = (file: File) =>
  isFileTypeValid(file, ['application/pdf'])

export const isFileValidJson = (file: File) =>
  isFileTypeValid(file, ['application/json'])
